import { lazy } from "react";
import { ReactComponent as HomeIcon } from "assets/svg/home-icon.svg";
import { ReactComponent as ProjectIcon } from "assets/svg/projects-icon.svg";
import { ReactComponent as TasksIcon } from "assets/svg/tasks-icon.svg";
import { ReactComponent as FormsIcon } from "assets/svg/forms-icon.svg";
import { ReactComponent as AnnouncementsIcon } from "assets/svg/announcements-icon.svg";
import { ReactComponent as ReportsIcon } from "assets/svg/reports-icon.svg";
import { ReactComponent as LocationsIcon } from "assets/svg/locations-icon.svg";
import { ReactComponent as HierarchyIcon } from "assets/svg/hierarchy-icon.svg";
// import { ReactComponent as LabelsIcon } from "assets/svg/labels-icon.svg";

import { ReactComponent as UsersIcon } from "assets/svg/users-icon.svg";
// import { ReactComponent as MastersIcon } from "assets/svg/masters-icon.svg";
// import { ReactComponent as RolesIcon } from "assets/svg/roles-icon.svg";
// import { ReactComponent as PermissionsIcon } from "assets/svg/permissions-icon.svg";
// import { ReactComponent as ModuleIcon } from "assets/svg/module-icon.svg";

// component imports
import Login from "components/pages/login/Login";
import Register from "components/pages/register/Register";
import ForgotPassword from "components/pages/otpverification/ForgotPassword";
import OtpVerification from "components/pages/otpverification/OtpVerification";
import VerifyPassword from "components/pages/otpverification/VerifyPassword";
// import Projects from "components/pages/projects/Projects";
// import Dashboard from "components/pages/dashboard/Dashboard";
// import Tasks from "components/pages/tasks/Tasks";
// import Forms from "components/pages/forms/Forms";
// import Reports from "components/pages/reports/Reports";
// import Announcements from "components/pages/announcements/Announcements";
// import NewForm from "components/pages/forms/NewForm";
// import NewReport from "components/pages/reports/NewReport";
// import FormResponse from "components/pages/formResponse/FormResponse";
// import Team from "components/pages/teams/Team";
import ResetPassword from "components/pages/resetpassword/ResetPassword";
import Announcements from "components/pages/announcements/Announcements";
import SingleAnnouncement from "components/pages/announcements/SingleAnnouncement";
import SingleReportDetails from "components/pages/reports/SingleReportDetails";
import Profile from "components/pages/Profile/Profile";
// import { RECURRING } from "services/apiEndpoints";
// import { Recurrings } from "components/pages/projects/Recurrings";
// import Reports from "components/pages/reports/Reports";

// lazy imports
const Dashboard = lazy(() => import("components/pages/dashboard/Dashboard"));
const Projects = lazy(() =>
  import("components/pages/projects/Projects").then((module) => ({
    default: module.Projects,
  }))
);
const Training = lazy(() =>
  import("components/pages/training/Training")
);
const Recurrings = lazy(() =>
  import("components/pages/projects/Recurrings").then((module) => ({
    default: module.Recurrings,
  }))
);
const Tasks = lazy(() =>
  import("components/pages/tasks/Tasks").then((module) => ({
    default: module.Tasks,
  }))
);
const Hierarchy = lazy(() =>
  import("components/pages/hierarchy").then((module) => ({
    default: module.Hierarchy,
  }))
);

const CreateTeam = lazy(() =>
  import("components/pages/hierarchy/CreateTeam").then((module) => ({
    default: module.CreateTeam,
  }))
);
const CreateRole = lazy(() =>
  import("components/pages/hierarchy/CreateRole").then((module) => ({
    default: module.CreateRole,
  }))
);
const Role = lazy(() =>
  import("components/pages/hierarchy/Role").then((module) => ({
    default: module.Role,
  }))
);
const CreateLocation = lazy(() =>
  import("components/pages/hierarchy/CreateLocation").then((module) => ({
    default: module.CreateLocation,
  }))
);
const CreateUsers = lazy(() =>
  import("components/pages/hierarchy/CreateUsers").then((module) => ({
    default: module.CreateUsers,
  }))
);

const Team = lazy(() => import("components/pages/teams/Team"));
// const Tasks = lazy(() => import("components/pages/tasks/Tasks"));
const Forms = lazy(() => import("components/pages/forms/Forms"));
const NewForm = lazy(() => import("components/pages/forms/NewForm"));
// const FormResponse = lazy(() =>
//   import("components/pages/formResponse/FormResponse")
// );
const Reports = lazy(() => import("components/pages/reports/Reports"));
const Notification = lazy(() => import("components/pages/notification/Notification"));

const NewReport = lazy(() => import("components/pages/reports/NewReport"));
const Users = lazy(() => import("components/pages/users/Users"));
const Location = lazy(() => import("components/pages/location/Location"));
const CreateProjectPage = lazy(() =>
  import("components/pages/projects/CreateProjectPage")
);
const Project = lazy(() =>
  import("components/pages/Profile/Profile")
);
const AddTrigger = lazy(() => import("components/pages/triggers/create/AddTrigger"));
const CreateAnnouncement = lazy(() =>
  import("components/pages/announcements/CreateAnnouncement/CreateAnnouncement")
);
// const Roles = lazy(() => import("components/pages/rolesandpermission/Roles"));
// const AddRole = lazy(() =>
//   import("components/pages/rolesandpermission/AddRole")
// );
// const Permissions = lazy(() =>
//   import("components/pages/rolesandpermission/Permissions")
// );
// const Entity = lazy(() => import("components/pages/entity/Entity"));
// const ViewPermission = lazy(() =>
//   import("components/pages/rolesandpermission/ViewPermission")
// );

// roles
export const roles = ["admin", "approver"];

// all paths
export const PATH = {
  // DEFAULT: {
  //     path: "/",
  //     pageName: "Home",
  // },
  publicRoutes: {
    LOGIN: {
      path: "/login",
      element: Login,
    },
    REGISTER: {
      path: "/register",
      element: Register,
    },
    FORGOT_PASSWORD: {
      path: "/forgot-password",
      element: ForgotPassword,
    },
    RESET_PASSWORD: {
      path: "/auth/reset-password/:token",
      element: ResetPassword,
    },
    OTP_VERIFICATION: {
      path: "/otp-verification",
      element: OtpVerification,
    },
    VERIFY_PASSWORD: {
      path: "/verify-password",
      element: VerifyPassword,
    },
  },
  privateRoutes: {
    HOME: {
      path: "/home",
      element: <Dashboard />,
      pageName: "Dashboard",
      sidebar: {
        show: true,
        icon: HomeIcon,
      },
      permissionName: "ViewDashboard",
    },
    ///
    RECURRING: {
      path: "/project/recurrings",
      element: <Recurrings />,
      pageName: "Recurrings",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "ViewPermissions",
    },
    ///

    PROJECTS: {
      path: "/project",
      element: <Projects />,
      pageName: "Projects",
      sidebar: {
        show: true,
        icon: ProjectIcon,
      },
      permissionName: "ViewProjects",
      children: [
        {
          path: "/project/recurrings",
          element: <Recurrings />,
          pageName: "Recurrings",
          sidebar: {
            show: true,
            icon: HierarchyIcon,
          },
          permissionName: "ViewPermissions",
        },
      ],
    },
    CREATE_PROJECTS: {
      path: "/project/create",
      element: <CreateProjectPage />,
      pageName: "Create Project",
      sidebar: {
        show: false,
        icon: ProjectIcon,
      },
      permissionName: "CreateProject",
    },
    // TEAM: {
    //   path: "/teams",
    //   element: <Team />,
    //   pageName: "Teams",
    //   sidebar: {
    //     show: true,
    //     icon: AnnouncementsIcon,
    //   },
    //   permissionName: "ViewTeams",
    // },
    TASKS: {
      path: "/tasks",
      element: <Tasks />,
      pageName: "Tasks",
      sidebar: {
        show: true,
        icon: TasksIcon,
      },
      permissionName: "ViewTasks",
    },
    SINGLE_SCORE: {
      path: "/scoring/:id?/formula/:formulaId?",
      element: <NewForm />,
      pageName: "Formula",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      // permissionName: "ViewTasks",
    },
    SCORE: {
      path: "/scoring/:id?",
      element: <NewForm />,
      pageName: "Score",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      permissionName: "CreateForm",
    },

    CONFIGURE: {
      path: "/configure/:id?",
      element: <NewForm />,
      pageName: "Configure",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      permissionName: "ConfigureForm",
    },
    TRIGGER: {
      path: "/triggers/:id?",
      element: <NewForm />,
      pageName: "Trigger",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      permissionName: "TriggerForm",
    },
    TRIGGER_CREATE: {
      path: "/create/triggers/:id?/:triggerId?",
      element: <NewForm />,
      pageName: "Trigger",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      permissionName: "TriggerFormCreate",
    },
    SCORE_ID: {
      path: "/score/:id?",
      element: <NewForm />,
      pageName: "Score",
      sidebar: {
        show: false,
        icon: TasksIcon,
      },
      permissionName: "ScoreID",
    },
    FORMS: {
      path: "/forms",
      element: <Forms />,
      pageName: "Forms",
      sidebar: {
        show: true,
        icon: FormsIcon,
      },
      permissionName: "ViewForms",
    },
    NEW_FORMS: {
      path: "forms/newforms/:formId?",
      element: <NewForm />,
      showBackIcon: true,
      permissionName: "CreateForm",
    },
    FORMS_ID: {
      path: "forms/:formId",
      element: <NewForm />,
      showBackIcon: true,
      permissionName: "EditForm",
    },
    REPORTS: {
      path: "/reports",
      element: <Reports />,
      pageName: "Reports",
      sidebar: {
        show: true,
        icon: ReportsIcon,
      },
      permissionName: "ViewReports",
      // children: [
      //   {
      //     path: "/reports/:id?",
      //     element: <div>adasd</div>,
      //     pageName: "Reports",
      //     sidebar: {
      //       show: false,
      //       icon: ReportsIcon,
      //     },
      //     permissionName: "ViewReports"
      //   }
      // ]
    },
    REPORTS_ID: {
      path: "/reports/:id?",
      element: <NewReport />,
      pageName: "Reports",
      sidebar: {
        show: false,

        icon: ReportsIcon,
      },
      permissionName: "ViewReports"
    },
    NOTIFICATION: {
      path: "/notification",
      element: <Notification />,
      pageName: "Notification",
      button: true,
      sidebar: {
        show: true,
        icon: ReportsIcon,

      },
      permissionName: "Notification"
    },
    Profile: {
      path: "/settings",
      element: <Profile />,
      pageName: "Profile Settings",
      button: true,
      sidebar: {
        show: false,
        icon: ReportsIcon,

      },
      permissionName: "ViewReports"
    },

    SINGLEREPORT: {
      path: "/singleReportDetails/:id?/:formId?",
      element: <SingleReportDetails />,
      pageName: "Reports",
      sidebar: {
        show: false,

        icon: ReportsIcon,
      },
      permissionName: "ViewReports"
    },
    NEW_REPORT: {
      path: "/reports/newreport",
      // pageName: "Reports",
      element: <NewReport />,
      showBackIcon: true,
    },
    LOCATION: {
      path: "/location",
      element: <Location />,
      pageName: "Location",
      sidebar: {
        show: true,
        icon: LocationsIcon,
      },
      permissionName: "ViewTasks",
    },
    USERS: {
      path: "/users",
      element: <Users />,
      pageName: "Users",
      sidebar: {
        show: true,
        icon: UsersIcon,
      },
      permissionName: "ViewUsers",
    },
    ROLE: {
      path: "/hierarchy/role",
      element: <Role />,
      pageName: "Role",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "ViewRoleHierarchy",
    },
    ANNOUCEMENTS: {
      path: "/announcements",
      element: <Announcements />,
      pageName: "Announcements",
      sidebar: {
        show: true,
        icon: HierarchyIcon,
      },
      permissionName: "Announcements",
    },
    TRAINING: {
      path: "/training",
      element: <Training />,
      pageName: "Training",
      sidebar: {
        show: true,
        icon: HierarchyIcon,
      },
      permissionName: "Training",
    },
    ANNOUCEMENTS_ID: {
      path: "/announcements/:id?",
      element: <SingleAnnouncement />,
      pageName: "Announcements",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "Announcements",
    },
    CREATE_ANNOUCEMENTS: {
      path: "/announcements/create",
      element: <CreateAnnouncement />,
      pageName: "Create Announcement",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "createAnnouncements",
    },
    CREATE_ROLE: {
      path: "/hierarchy/role/form/:id?",
      element: <CreateRole />,
      pageName: "Role Form",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "EditRoleHierarchy",
    },
    HIERARCHY: {
      path: "/hierarchy",
      element: <Hierarchy />,
      pageName: "Hierarchy",
      sidebar: {
        show: true,
        icon: HierarchyIcon,
      },
      permissionName: "ViewHierarchy",
      children: [
        {
          path: "/hierarchy/role",
          element: <CreateRole />,
          pageName: "Role",
          sidebar: {
            show: true,
            icon: HierarchyIcon,
          },
          permissionName: "ViewRoleHierarchy",
        },
      ],
    },
    CREATE_TEAM: {
      path: "/hierarchy/team/form/:id?",
      element: <CreateTeam />,
      pageName: "Create Team",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "EditHierarchy",
    },
    CREATE_LOCATION: {
      path: "/hierarchy/location/form/:id?",
      element: <CreateLocation />,
      pageName: "Create Location",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "ViewHierarchy",
    },
    CREATE_USERS: {
      path: "/hierarchy/user/form/:id?",
      element: <CreateUsers />,
      pageName: "Create Users",
      sidebar: {
        show: false,
        icon: HierarchyIcon,
      },
      permissionName: "CreateUser",
    },
    // LABELS: {
    //   path: "/labels",
    //   element: <Projects />,
    //   pageName: "Labels",
    //   sidebar: {
    //     show: true,
    //     icon: LabelsIcon,
    //   },
    //   permissionName: "ViewLabels"
    // },
    // SENSORS: {
    //   path: "/sensors",
    //   element: <Projects />,
    //   pageName: "Sensors",
    //   sidebar: {
    //     show: true,
    //     icon: AnnouncementsIcon,
    //   },
    //   permissionName: "ViewSensors"
    // },
    // DOCUMENTATION: {
    //   path: "/documentation",
    //   element: <Projects />,
    //   pageName: "Documentation",
    //   sidebar: {
    //     show: true,
    //     icon: LocationsIcon,
    //   },
    //   permissionName: "ViewDocumentation"
    // },
    // Chat: {
    //   path: "/chat",
    //   element: <Projects />,
    //   pageName: "Chat",
    //   sidebar: {
    //     show: true,
    //     icon: UsersIcon,
    //   },
    //   permissionName: "ViewChat"
    // },
    // ROLES_AND_PERMISSION: {
    //   path: "/roles-and-permissions",
    //   pageName: "Roles & Permission",
    //   sidebar: {
    //     show: true,
    //     icon: RolesIcon
    //   },
    //   permissionName: "ViewRoles",
    //   children: {
    //     ROLES: {
    //       path: "/roles-and-permissions/roles",
    //       element: <Roles />,
    //       pageName: "Roles",
    //       sidebar: {
    //         show: true,
    //         icon: RolesIcon,
    //       },
    //       permissionName: "ViewRoles"
    //     },
    //     ADD_ROLE: {
    //       path: "/roles-and-permissions/roles/add",
    //       element: <AddRole />,
    //       pageName: "Add Role"
    //     },
    //     EDIT_ROLES: {
    //       path: "/roles-and-permissions/roles/:roleId",
    //       element: <AddRole />,
    //       pageName: "Edit Role",
    //     },
    //     VIEW_PERMISSION: {
    //       path: "/roles-and-permissions/roles/permission/:roleId",
    //       element: <ViewPermission />,
    //       pageName: "Permissions",
    //     },
    //     PERMISSIONS: {
    //       path: "/roles-and-permissions/permissions",
    //       element: <Permissions />,
    //       pageName: "Permissions",
    //       sidebar: {
    //         show: true,
    //         icon: PermissionsIcon,
    //       },
    //       permissionName: "ViewPermissions"
    //     },
    //     ENTITY: {
    //       path: "/roles-and-permissions/entity",
    //       element: <Entity />,
    //       pageName: "Modules",
    //       sidebar: {
    //         show: true,
    //         icon: ModuleIcon,
    //       },
    //       permissionName: "ViewEntity"
    //     },
    //   }
    // },
  },
};

export const entityNames = {
  // [PATH.privateRoutes.ROLES_AND_PERMISSION.children.ROLES.path] : "role",
  // [PATH.privateRoutes.ROLES_AND_PERMISSION.children.ENTITY.path] : "entity",
  // [PATH.privateRoutes.ROLES_AND_PERMISSION.children.PERMISSIONS.path] : "permission",
  // [PATH.privateRoutes.ROLES_AND_PERMISSION.path] : "permission",
  [PATH.privateRoutes.USERS.path]: "user",
  [PATH.privateRoutes.HOME.path]: "ccDetails",
};

//this is temporary to display all pages when permission wise routing is applied
export const tempPagesArray = [
  ...Object.values(PATH.privateRoutes).map((x) => x.path),
];

// pagination
export const PAGINATION = {
  ROWS_PER_PAGE: [10, 25, 50],
  DEFAULT_ROWS_PER_PAGE: 25,
  DEFAULT_CURRENT_PAGE: 1,
  NO_BREAK_PAGE: 4,
};

// constants
export const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

export const statusColors = {
  pending: {
    background: "#FFEBF9",
    color: "#DE0097",
  },
  success: {
    background: "#D2FBF0",
    color: "#0AAB83",
  },
};

export const homeTabNames = ["Approved", "Pending", "Rejected"];

export const masterTabNames = ["Property Code", false, "Unit Code", "GL Code"];

export const methodOptions = [
  { label: "GET", value: "GET" },
  { label: "POST", value: "POST" },
  { label: "PUT", value: "PUT" },
  { label: "DELETE", value: "DELETE" },
  { label: "PATCH", value: "PATCH" },
];


// hardcoded values
export const MAX_UPLOAD_FILE = 10